// Import translation files
import deAuth from './locales/de/auth.json';
import deCommon from './locales/de/common.json';
import deMarketing from './locales/de/marketing.json';
import deProductTour from './locales/de/product-tour.json';
import deSettings from './locales/de/settings.json';
import deWelcome from './locales/de/welcome.json';
import enAnalytics from './locales/en/analytics.json';
import enAnnouncements from './locales/en/announcements.json';
import enAuth from './locales/en/auth.json';
import enBugReport from './locales/en/bug-report.json';
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enDocumentation from './locales/en/documentation.json';
import enEmployees from './locales/en/employees.json';
import enEnquiries from './locales/en/enquiries.json';
import enExpenses from './locales/en/expenses.json';
import enFacilities from './locales/en/facilities.json';
import enInvitations from './locales/en/invitations.json';
import enLegal from './locales/en/legal.json';
import enMaintenance from './locales/en/maintenance.json';
import enMarketing from './locales/en/marketing.json';
import enMessages from './locales/en/messages.json';
import enNotificationSettings from './locales/en/notification-settings.json';
import enPayments from './locales/en/payments.json';
import enProductTour from './locales/en/product-tour.json';
import enResidentFeatures from './locales/en/resident-features.json';
import enResidents from './locales/en/residents.json';
import enSettings from './locales/en/settings.json';
import enSubscription from './locales/en/subscription.json';
import enWelcome from './locales/en/welcome.json';
import nlAuth from './locales/nl/auth.json';
import nlCommon from './locales/nl/common.json';
import nlMarketing from './locales/nl/marketing.json';
import nlProductTour from './locales/nl/product-tour.json';
import nlSettings from './locales/nl/settings.json';
import nlWelcome from './locales/nl/welcome.json';

import ptAnalytics from './locales/pt/analytics.json';
import ptAnnouncements from './locales/pt/announcements.json';
import ptAuth from './locales/pt/auth.json';
import ptBugReport from './locales/pt/bug-report.json';
import ptCommon from './locales/pt/common.json';
import ptDashboard from './locales/pt/dashboard.json';
import ptDocumentation from './locales/pt/documentation.json';
import ptEmployees from './locales/pt/employees.json';
import ptEnquiries from './locales/pt/enquiries.json';
import ptExpenses from './locales/pt/expenses.json';
import ptFacilities from './locales/pt/facilities.json';
import ptInvitations from './locales/pt/invitations.json';
import ptLegal from './locales/pt/legal.json';
import ptMaintenance from './locales/pt/maintenance.json';
import ptMarketing from './locales/pt/marketing.json';
import ptMessages from './locales/pt/messages.json';
import ptNotificationSettings from './locales/pt/notification-settings.json';
import ptPayments from './locales/pt/payments.json';
import ptProductTour from './locales/pt/product-tour.json';
import ptResidentFeatures from './locales/pt/resident-features.json';
import ptResidents from './locales/pt/residents.json';
import ptSettings from './locales/pt/settings.json';
import ptSubscription from './locales/pt/subscription.json';
import ptWelcome from './locales/pt/welcome.json';

export const resources = {
    // Other namespaces use the configured English fallback until localized.
    de: {
        auth: deAuth,
        common: deCommon,
        marketing: deMarketing,
        'product-tour': deProductTour,
        settings: deSettings,
        welcome: deWelcome,
    },
    nl: {
        auth: nlAuth,
        common: nlCommon,
        marketing: nlMarketing,
        'product-tour': nlProductTour,
        settings: nlSettings,
        welcome: nlWelcome,
    },

    en: {
        common: enCommon,
        auth: enAuth,
        'bug-report': enBugReport,
        dashboard: enDashboard,
        payments: enPayments,
        expenses: enExpenses,
        employees: enEmployees,
        announcements: enAnnouncements,
        maintenance: enMaintenance,
        marketing: enMarketing,
        'product-tour': enProductTour,
        facilities: enFacilities,
        enquiries: enEnquiries,
        residents: enResidents,
        'resident-features': enResidentFeatures,
        settings: enSettings,
        messages: enMessages,
        'notification-settings': enNotificationSettings,
        invitations: enInvitations,
        legal: enLegal,
        subscription: enSubscription,
        welcome: enWelcome,
        analytics: enAnalytics,
        documentation: enDocumentation,
    },
    pt: {
        common: ptCommon,
        auth: ptAuth,
        'bug-report': ptBugReport,
        dashboard: ptDashboard,
        payments: ptPayments,
        expenses: ptExpenses,
        employees: ptEmployees,
        announcements: ptAnnouncements,
        maintenance: ptMaintenance,
        marketing: ptMarketing,
        'product-tour': ptProductTour,
        facilities: ptFacilities,
        enquiries: ptEnquiries,
        residents: ptResidents,
        'resident-features': ptResidentFeatures,
        settings: ptSettings,
        messages: ptMessages,
        'notification-settings': ptNotificationSettings,
        invitations: ptInvitations,
        legal: ptLegal,
        subscription: ptSubscription,
        welcome: ptWelcome,
        analytics: ptAnalytics,
        documentation: ptDocumentation,
    },
};
